<template>
  <div class="notification-banner">
    <div class="notification-banner__text" v-html="msg" />
  </div>
</template>

<script>
  export default {
    name: 'NotificationBanner',
    props: {
      msg: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .notification-banner {
    padding: 2em 1em;
    background-color: $c-error;

    @include mobile {
      position: relative;
      right: 50%;
      left: 50%;
      width: 100vw;
      margin-right: -50vw;
      margin-left: -50vw;
    }

    &__text {
      max-width: 430px;
      margin: 0 auto;

      &,
      * {
        font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
        font-size: 16px;
        line-height: 1.38;
        color: $c-black;
        text-align: center;
      }

      strong {
        font-weight: bold;
      }

      em {
        font-style: italic;
      }

      sup {
        vertical-align: super;
      }

      sub {
        vertical-align: sub;
      }

      h1 {
        font-size: 2.2em;
      }

      h2 {
        font-size: 2em;
      }

      h3 {
        font-size: 1.8em;
      }

      h4 {
        font-size: 1.6em;
      }

      h5 {
        font-size: 1.4em;
      }

      h6 {
        font-size: 1.2em;
      }

      p,
      ol,
      ul,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      li {
        list-style: inside;
      }

      ol {
        li {
          list-style: inside decimal;
        }
      }
    }
  }
</style>
